import { FC, useEffect } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';

interface PrivateRouteProps {
  token: string;
}

const PrivateRoute: FC<PrivateRouteProps> = ({token}) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    if (token && window.location.pathname === '/') {
      navigate('/acceuil');
    }
  }, [window.location.pathname]);
  
  return (
    token ? <Outlet /> : <Navigate to="/sign-in" />
  );
};

export default PrivateRoute;
